module.exports = __webpack_public_path__ + "static/img/CgoRDGRCUICAcVdZAAjNrRVyxVo659.3c4c07f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGRCUICAcVdZAAjNrRVyxVo659.png
// module id = Ml6E
// module chunks = 73